// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_n1-1";
export var rowFirst = "_n1-3";
export var rowLast = "_n1-5";
export var rowMiddle = "_n1-4";
export var ticketListScroll = "_n1-2";
export var ticketStack = "_n1-0";